import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import Button from '@mui/material/Button';
import MenuItem from '@mui/material/MenuItem';
import { observer } from 'mobx-react-lite';
import { useStore } from '../stores/store';
import Login from '../../features/user/forms/Login';
import { Avatar, CardMedia, Link, Tooltip } from '@mui/material';
import logoWhite60 from '../../assets/logo-white-60.png';
import GenerateNavBarMenuDesktop from '../common/navBarElements/GenerateNavBarMenuDesktop';
import Slide from '@mui/material/Slide';
import useScrollTrigger from '@mui/material/useScrollTrigger';
import { router } from '../router/Routes';
import UserPng from '../../assets/user.png';
import {
    partnerRoles, partnerUserRoles,
    t1aAdmin
} from '../common/options/adminOptions';
import { collectionTab, reportingTab } from '../common/options/navBarOpt';
import GenerateNavBarMenuMobile from '../common/navBarElements/GenerateNavBarMenuMobile';
import MenuIcon from '@mui/icons-material/Menu';

const topbarLink = {
    alignItems: 'left',
    marginRight: 3,
    cursor: 'pointer',
    whiteSpace: 'nowrap',
    color: '#fff'
} as const;

export default observer(function NavBar() {

    const { userStore, modalStore } = useStore();
    const { isLoggedIn, logout, user, changeUserRole } = userStore;

    const [anchors, setAnchors] = React.useState<[] | HTMLElement[]>([]);

    // const userRoleText = user?.roles.filter(x => x.role === user.currentUserRole)[0].roleText;
    const handleOpenAnchors = (event: React.MouseEvent<HTMLElement>) => {
        const currentAnchors = [...anchors];
        const selectedAnchor = currentAnchors.find(x => x.id === event.currentTarget.id);

        if (!selectedAnchor) {
            currentAnchors.push(event.currentTarget);
            setAnchors(currentAnchors);
        }
    };
    const handleCloseAnchors = (routeId?: string, userRole?: string) => {

        if (userRole) {
            changeUserRole(userRole);
        }

        if (routeId)
            router.navigate(routeId);
        setAnchors([]);
    };
   
    const trigger = useScrollTrigger();

    return (
        <Slide in={!trigger}>
            <AppBar component="nav" elevation={0} sx={{ backgroundColor: '#003755', p: 2 }}>
                <Toolbar>
                    {/* Mobile view */}
                    <Box sx={{
                        flexGrow: 1,
                        display: { xs: 'flex', md: 'none', alignItems: 'center' }
                    }}>
                        <IconButton
                            size="large"
                            aria-label="account of current user"
                            aria-controls="menu-appbar"
                            id="menu-appbar"
                            aria-haspopup="true"
                            onClick={handleOpenAnchors}
                            sx={{ color: '#fff' }}
                        >
                            <MenuIcon />

                        </IconButton>
                        {/* {user && <Typography>{user.roles.filter(x => x.role === user.currentUserRole)[0].roleText}</Typography>} */}
                        <Menu
                            id="menu-appbar"
                            anchorEl={anchors.find(x => x.id === "menu-appbar")}
                            anchorOrigin={{
                                vertical: 'center',
                                horizontal: 'left',
                            }}
                            keepMounted
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'left',
                            }}
                            open={Boolean(anchors.some(x => x.id === "menu-appbar"))}
                            onClose={() => handleCloseAnchors()}
                            sx={{
                                display: { xs: 'block', md: 'none' },
                                '& .MuiPaper-root': {
                                    minWidth: 100,
                                    maxWidth: 120,
                                    bgcolor: '#DAE5F1',
                                }
                            }}
                        >
                            {user && (partnerUserRoles.includes(user.currentUserRole) || (partnerRoles.includes(user.currentUserRole))) &&
                                <MenuItem key="Collection" aria-label="collection"
                                    aria-controls="collection-appbar"
                                    id="collection-appbar"
                                    aria-haspopup="true"
                                    onClick={handleOpenAnchors}
                                    color="inherit">
                                    <Typography>Collection</Typography>
                                </MenuItem>
                            }
                            {user && (user.currentUserRole === t1aAdmin) &&
                                <MenuItem key="AdminCollection" aria-label="admincollection"
                                    aria-controls="admin-collection-appbar"
                                    id="admin-collection-appbar"
                                    aria-haspopup="true"
                                    onClick={handleOpenAnchors}
                                    color="inherit">
                                    <Typography>Collection</Typography>
                                </MenuItem>
                            }
                            {/* {user &&
                                <MenuItem key="Reporting"
                                    aria-label="reporting"
                                    aria-controls="reporting-appbar-mobile"
                                    id="reporting-appbar-mobile"
                                    aria-haspopup="true"
                                    onClick={handleOpenAnchors}
                                    color="inherit"
                                    >
                                    <Typography>Reporting</Typography>
                                </MenuItem>
                            } */}


                            {user && user.currentUserRole === t1aAdmin &&
                                <MenuItem key="appUser" aria-label="appUser"
                                    aria-controls="appUser-appbar"
                                    id="appUser-appbar"
                                    aria-haspopup="true"
                                    onClick={() => handleCloseAnchors('/admintempsignups')}
                                    color="inherit">
                                    <Typography>Users</Typography>
                                </MenuItem>
                            }
                            {/* {user && (partnerRoles.includes(user.currentUserRole) || user.currentUserRole === t1aAdmin) &&
                                <MenuItem key="NewUser"
                                    aria-label="NewUser"
                                    aria-controls="newuser-appbar-mobile"
                                    id="newuser-appbar-mobile"
                                    aria-haspopup="true"
                                    onClick={handleOpenAnchors}
                                    color="inherit">
                                    <Typography>
                                        Partners
                                    </Typography>
                                </MenuItem>
                            }
                            {user && (partnerUserRoles.includes(user.currentUserRole)) &&
                                <MenuItem key="resellercustomeruser"
                                    aria-label="resellercustomeruser"
                                    aria-controls="resellercustomeruser-appbar"
                                    id="resellercustomeruser-appbar"
                                    aria-haspopup="true"
                                    onClick={() => handleCloseAnchors('/newsubpartneruserpanel')}
                                    color="inherit">
                                    <Typography>
                                        Sub-Partner
                                    </Typography>
                                </MenuItem>
                            } */}
                            {user &&
                                <MenuItem key="Password" aria-label="Password"
                                    aria-controls="password-appbar"
                                    id="password-appbar"
                                    aria-haspopup="true"
                                    onClick={() => handleCloseAnchors('/password')}
                                    color="inherit">
                                    <Typography>Password</Typography>
                                </MenuItem>
                            }
                            {user &&
                                <MenuItem key="Logout" aria-label="User"
                                    aria-controls="Logout-appbar"
                                    id="Logout-appbar"
                                    aria-haspopup="true"
                                    onClick={() => {
                                        logout();
                                        handleCloseAnchors('/');
                                    }}
                                    color="inherit">
                                    <Typography>Logout</Typography>
                                </MenuItem>
                            }
                            {/* <Button
                                title='Packing Instructions'
                                key="Packing Instructions"
                                onClick={() => handleCloseAnchors('/')}
                                sx={topbarLink}
                                href="https://www.t1agroup.com/packing-instructions/"
                                target="_blank"
                                rel="noreferrer"
                            >
                                Packing
                            </Button> */}
                            <MenuItem component={Link} key="packinginstructions" href="https://www.t1agroup.com/packing-instructions/"
                                target="_blank"
                                rel="noreferrer">
                                <Typography >Packing Inst.</Typography>
                            </MenuItem>
                            {!isLoggedIn &&
                                <React.Fragment>
                                    <MenuItem key="Login" aria-label="Login"
                                        aria-controls="Login-appbar"
                                        id="Login-appbar"
                                        aria-haspopup="true"
                                        onClick={() => modalStore.openModal(<Login />)}
                                    >
                                        <Typography>
                                            Login
                                        </Typography>
                                    </MenuItem>
                                    <MenuItem key="Signup" aria-label="Signup"
                                        aria-controls="Signup-appbar"
                                        id="Signup-appbar"
                                        aria-haspopup="true"
                                        onClick={() => router.navigate('/signup')}
                                    >
                                        <Typography>
                                            Sign up
                                        </Typography>
                                    </MenuItem>
                                </React.Fragment>
                            }
                        </Menu>
                        <GenerateNavBarMenuMobile anchors={anchors}
                            menuId={"reporting-appbar-mobile"}
                            handleCloseAnchors={handleCloseAnchors}
                            menuItems={reportingTab}
                        />
                    </Box>
                    {/* Desktop View */}
                    <Box sx={{ display: { xs: 'flex', md: 'flex' }, alignItems: 'flex-end', height: '100%' }}>
                        <CardMedia
                            component="img"
                            sx={{ width: { xs: 80, md: 120 } }}
                            image={logoWhite60}
                            alt="T1A Logo"
                            onClick={() => router.navigate('/')}
                        />
                    </Box>
                    <Box sx={{ flexGrow: 100, display: { xs: 'none', md: 'flex' }, marginLeft: 8 }}>
                        {/* {user && (partnerUserRoles.includes(user.currentUserRole) || (partnerRoles.includes(user.currentUserRole))) && */}
                        <React.Fragment>
                            <Button
                                title='Collection'
                                key="collectionBig"
                                sx={topbarLink}
                                aria-label="collectionBig"
                                aria-controls="collection-appbarBig"
                                id="collection-appbarBig"
                                aria-haspopup="true"
                                onClick={handleOpenAnchors}
                            >
                                Collection
                            </Button>
                            {/* <Button
                                title='Reporting'
                                key="ReportingBig"
                                sx={topbarLink}
                                aria-label="reportingBig"
                                aria-controls="reporting-appbarBig"
                                id="reporting-appbarBig"
                                aria-haspopup="true"
                                onClick={handleOpenAnchors}
                                color="inherit"
                            >
                                Reporting
                            </Button> */}
                        </React.Fragment>
                        {/* } */}
                        {user && (user.currentUserRole === t1aAdmin) &&
                            <React.Fragment>
                                <Button
                                    title='Collection'
                                    key="AdminCollection"
                                    id='admin-collection'
                                    sx={topbarLink}
                                    onClick={() => handleCloseAnchors('/admincollection')}
                                >
                                    Admin Collection
                                </Button>
                                {/* <Button
                                    title='Reporting'
                                    key="ReportingBig"
                                    sx={topbarLink}
                                    aria-label="reportingBig"
                                    aria-controls="reporting-appbarBig"
                                    id="reporting-appbarBig"
                                    aria-haspopup="true"
                                    onClick={handleOpenAnchors}
                                    color="inherit"
                                >
                                    Reporting
                                </Button> */}
                            </React.Fragment>
                        }
                        <Button
                            title='Packing Instructions'
                            key="Packing Instructions"
                            onClick={() => handleCloseAnchors('/')}
                            sx={topbarLink}
                            href="https://www.t1agroup.com/packing-instructions/"
                            target="_blank"
                            rel="noreferrer"
                        >
                            Packing Instructions
                        </Button>
                        <Box sx={{ display: 'flex', flexGrow: 1, justifyContent: 'flex-end', alignItems: 'flex-start' }}>
                            {user &&
                                <Box sx={{ display: { xs: 'flex', md: 'flex', alignItems: 'center' } }}>
                                    <Typography>Hi {user?.username.toUpperCase()}</Typography>
                                    <Tooltip title="Profile">
                                        <IconButton key="AdminMenu"
                                            sx={topbarLink}
                                            aria-label="AdminMenu"
                                            aria-controls="menu-appbar-admin"
                                            id="menu-appbar-admin"
                                            aria-haspopup="true"
                                            onClick={handleOpenAnchors}
                                            color="inherit"
                                        >
                                            <Avatar alt="Pic" src={user?.image || UserPng} />
                                        </IconButton>
                                    </Tooltip>
                                    <Menu
                                        sx={{
                                            display: { xs: 'block', md: 'block' },
                                            mt: '20px',
                                            '& .MuiPaper-root': {
                                                minWidth: 100,
                                                bgcolor: '#DAE5F1'
                                            }
                                        }}
                                        id="menu-appbar-admin"
                                        anchorEl={anchors.find(x => x.id === "menu-appbar-admin")}
                                        anchorOrigin={{
                                            vertical: 'center',
                                            horizontal: 'right',
                                        }}
                                        keepMounted
                                        transformOrigin={{
                                            vertical: 'top',
                                            horizontal: 'right',
                                        }}
                                        open={Boolean(anchors.some(x => x.id === "menu-appbar-admin"))}
                                        onClose={() => handleCloseAnchors()}

                                    >
                                        {user && user.currentUserRole === t1aAdmin &&
                                            <MenuItem key="appUser" aria-label="appUser"
                                                aria-controls="appUser-appbar"
                                                id="appUser-appbar"
                                                aria-haspopup="true"
                                                onClick={() => handleCloseAnchors('/admintempsignups')}
                                                color="inherit">
                                                <Typography>Users</Typography>
                                            </MenuItem>
                                        }
                                        {/* {user && (partnerRoles.includes(user.currentUserRole) || user.currentUserRole === t1aAdmin) &&
                                            <MenuItem key="NewUser"
                                                aria-label="NewUser"
                                                aria-controls="newuser-appbar"
                                                id="newuser-appbar"
                                                aria-haspopup="true"
                                                onClick={handleOpenAnchors}
                                                color="inherit">
                                                <Typography>
                                                    Partners
                                                </Typography>
                                            </MenuItem>
                                        } */}
                                        {/* MenuItem for reseller and customer user(Sub Partner) */}
                                        {/* {user && (partnerUserRoles.includes(user.currentUserRole)) &&
                                            <MenuItem key="resellercustomeruser"
                                                aria-label="resellercustomeruser"
                                                aria-controls="resellercustomeruser-appbar"
                                                id="resellercustomeruser-appbar"
                                                aria-haspopup="true"
                                                onClick={() => handleCloseAnchors('/newsubpartneruserpanel')}
                                                color="inherit">
                                                <Typography>
                                                    Sub-Partner
                                                </Typography>
                                            </MenuItem>
                                        } */}
                                        {/* <Menu
                                            id="newuser-appbar"
                                            anchorEl={anchors.find(x => x.id === "newuser-appbar")}
                                            anchorOrigin={{
                                                vertical: 'center',
                                                horizontal: 'left',
                                            }}
                                            keepMounted
                                            transformOrigin={{
                                                vertical: 'top',
                                                horizontal: 'right',
                                            }}
                                            open={Boolean(anchors.some(x => x.id === "newuser-appbar"))}
                                            onClose={() => handleCloseAnchors()}
                                            sx={{
                                                // display: { xs: 'block', md: 'block' },
                                                display: 'flex',
                                                '& .MuiPaper-root': {
                                                    minWidth: 100,
                                                    bgcolor: '#DAE5F1'
                                                }
                                            }}
                                        >
                                            <MenuItem key="Create" aria-label="Create"
                                                aria-controls="create-appbar"
                                                id="create-appbar"
                                                aria-haspopup="true"
                                                onClick={() => handleCloseAnchors(user.currentUserRole === t1aAdmin ?
                                                    '/newadminuserpanel' : '/newsubpartneruserpanel')}
                                                color="inherit">
                                                <Typography>Partner</Typography>
                                            </MenuItem>
                                            <MenuItem key="Request" aria-label="Request"
                                                aria-controls="request-appbar"
                                                id="request-appbar"
                                                aria-haspopup="true"
                                                onClick={() => handleCloseAnchors('/newadmintempsignup')}
                                                color="inherit">
                                                <Typography>
                                                    Request
                                                </Typography>
                                            </MenuItem>
                                        </Menu> */}
                                        {/* {user &&
                                            <MenuItem key="Roles" aria-label="Roles"
                                                aria-controls="roles-appbar"
                                                id="roles-appbar"
                                                aria-haspopup="true"
                                                onClick={handleOpenAnchors}
                                                color="inherit">
                                                <Typography>
                                                    Roles
                                                </Typography>
                                            </MenuItem>
                                        } */}
                                        {/* <Menu
                                            id="roles-appbar"
                                            anchorEl={anchors.find(x => x.id === "roles-appbar")}
                                            anchorOrigin={{
                                                vertical: 'center',
                                                horizontal: 'left',
                                            }}
                                            keepMounted
                                            transformOrigin={{
                                                vertical: 'top',
                                                horizontal: 'right',
                                            }}
                                            open={Boolean(anchors.some(x => x.id === "roles-appbar"))}
                                            onClose={() => handleCloseAnchors()}
                                            sx={{
                                                display: { xs: 'block', md: 'block' },
                                                '& .MuiPaper-root': {
                                                    minWidth: 100,
                                                    bgcolor: '#DAE5F1'
                                                }
                                            }}
                                        >
                                            {user && user.roles.map((role, index) =>
                                                <MenuItem key={index} aria-label="role"
                                                    aria-controls="role-appbar"
                                                    id="role-appbar"
                                                    aria-haspopup="true"
                                                    onClick={() => {
                                                        handleCloseAnchors(role.routeId, role.role)
                                                    }}
                                                    color="inherit">
                                                    <Typography color={user.currentUserRole === role.role ? 'red' : 'black'}>
                                                        {role.roleText}
                                                    </Typography>
                                                </MenuItem>
                                            )
                                            }
                                        </Menu> */}
                                        <MenuItem key="Password" aria-label="Password"
                                            aria-controls="password-appbar"
                                            id="password-appbar"
                                            aria-haspopup="true"
                                            onClick={() => handleCloseAnchors('/password')}
                                            color="inherit">
                                            <Typography>Password</Typography>
                                        </MenuItem>
                                        <MenuItem key="Logout" aria-label="User"
                                            aria-controls="Logout-appbar"
                                            id="Logout-appbar"
                                            aria-haspopup="true"
                                            onClick={() => {
                                                logout();
                                                handleCloseAnchors('/');
                                            }}
                                            color="inherit">
                                            <Typography>Logout</Typography>
                                        </MenuItem>
                                    </Menu>
                                </Box>
                            }
                        </Box>
                        {!isLoggedIn &&
                            <>
                                <Button
                                    title="Login"
                                    key="login"
                                    onClick={() => modalStore.openModal(<Login />)}
                                    sx={topbarLink}
                                >
                                    Login
                                </Button>
                                <Button
                                    title='Signup'
                                    key="signup"
                                    onClick={() => router.navigate('/signup')}
                                    sx={topbarLink}
                                >
                                    Sign up
                                </Button>
                            </>
                        }
                    </Box>
                    <GenerateNavBarMenuDesktop anchors={anchors}
                        menuId={"reporting-appbarBig"}
                        handleCloseAnchors={handleCloseAnchors}
                        menuItems={reportingTab}
                    />
                    <GenerateNavBarMenuDesktop anchors={anchors}
                        menuId={"collection-appbarBig"}
                        handleCloseAnchors={handleCloseAnchors}
                        menuItems={collectionTab}
                    />


                </Toolbar>
            </AppBar >
        </Slide >
    );
})